<template>
  <div>
    <v-dialog v-model="show" max-width="800px" lazy>
      <v-card>
        <div class="scroll-here">
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md9>
                      <v-text-field
                        v-model="editedItem.name"
                        @keyup.enter="save"
                        label="Name"
                        ref="focusName"
                        v-validate="'required'"
                        :error-messages="errors.collect('name')"
                        prepend-icon="group"
                        data-vv-name="name"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md3>
                      <v-text-field
                        v-model="editedItem.code"
                        @keyup.enter="save"
                        label="Code"
                        v-validate="'required'"
                        :error-messages="errors.collect('code')"
                        prepend-icon="assignment"
                        data-vv-name="code"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="byLaws"
                    v-model="editedItem.byLaws"
                    menu-props="auto"
                    label="Required in By-Laws"
                    hide-details
                    prepend-icon="book"
                    @keyup.enter="save"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    :items="statuses"
                    v-model="editedItem.active"
                    menu-props="auto"
                    label="Status"
                    hide-details
                    prepend-icon="traffic"
                    @keyup.enter="save"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-autocomplete
                    :items="yearSelect"
                    v-model="editedItem.year"
                    label="Year"
                    hide-details
                    prepend-icon="event"
                    @keyup.enter="save"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    :items="execGroupList"
                    v-model="editedItem.ExecGroupId"
                    label="Executive Group"
                    hide-details
                    prepend-icon="mdi-account-supervisor"
                    @keyup.enter="save"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    :items="committeeList"
                    v-model="editedItem.parentId"
                    label="Parent Committee"
                    hide-details
                    prepend-icon="mdi-account-child"
                    @keyup.enter="save"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.notes"
                    label="Notes"
                    prepend-icon="notes"
                    counter
                    maxlength="255"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </div>

        <v-card-actions>
          <v-btn
            color="red darken-1"
            flat
            @click.native="deleteItem"
          >Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            v-if="saving"
            @click.stop="show=false"
          >Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            transition="fade-transition"
            v-if="!saving"
            flat
            @click.stop="show=false"
          >Close</v-btn>
          <v-btn
            color="blue darken-1"
            dark
            transition="fade-transition"
            v-if="saving"
            @click.native="save"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

export default {
  props: ['visible', 'item', 'isEdit', 'isOpen'],

  $_veeValidate: {
    validator: 'new'
  },

  data () {
    return {
      menu1: false,
      menu2: false,
      formattedDate: '',
      formattedTitleDate: '',
      editedCommittee: {
        id: '',
        title: '',
        userId: 0,
        committeeId: 0
      },
      firstTime: true,
      saving: false,
      showSaving: this.isOpen,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      statuses: [
        { text: 'Inactive', value: false },
        { text: 'Active', value: true }
      ],
      byLaws: [
        { text: 'No', value: false },
        { text: 'Yes', value: true }
      ],
      execGroupList: [],
      committeeList: [],
      yearSelect: [],
      editedItem: this.item,
      defaultItem: {
        id: 0,
        name: '',
        code: '',
        byLaws: '',
        active: '',
        password: '',
        year: '',
        ExecGroupId: '',
        parentId: ''
      },
      currentYear: 0
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear

    for (var i = this.currentYear; i >= 2013; i--) {
      this.yearSelect.push(i)
    }

    this.getExecGroups()
    this.getCommitteeItems()
  },

  mounted () {
    this.$validator.localize('en', this.dictionary)
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
          // Object.assign(this.$data, this.$options.data())
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        // console.log('test')
        if (!this.showSaving) {
          this.saving = true
        }

        this.showSaving = false
      },
      deep: true
    }
  },

  methods: {
    loadItem () {
      if (this.isEdit) {
        this.editedItem = this.item
        this.getUser(this.editedItem)
      }
    },

    async getExecGroups () {
      try {
        const response = await Api().get('exec_groups/' + this.currentYear)
        this.execGroupList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getCommitteeItems () {
      try {
        const response = await Api().get('get_committees/' + this.currentYear)
        this.committeeList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async getUser (item) {
      try {
        const response = await Api().get('users/' + item.id)
        this.userDetail = response.data
        this.userDetail.password = ''
        // this.userCommittees = this.userDetail.Committees
        this.userAwards = this.userDetail.Awards

        this.userCommittees = this.userDetail.Committees.map(a => ({
          id: a.id,
          name: a.name,
          title: a.UserCommittee.title,
          year: a.year
        }))

        this.currentCommittees = this.userCommittees.filter(obj => {
          return obj.year === this.currentYear
        })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.saving = false
          this.snackbar.message = 'There were errors in the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
          this.editedItem.fullName = this.editedItem.firstName + ' ' + this.editedItem.lastName

          if (this.editedItem.id > 0) {
            this.updateItem(this.editedItem)
          } else {
            if (!this.editedItem.birthDate) {
              this.editedItem.birthDate = '1901-01-01'
            }

            this.editedItem.startDate = this.currentYear
            this.editedItem.RoleId = 2
            this.editedItem.TitleId = 4
            this.editedItem.Title.name = 'Wrangler'

            this.addItem(this.editedItem)
          }

          this.$emit('saveUser', this.editedItem)
        }
      })
    },

    async addItem (item) {
      try {
        const response = await Api().post('users', item)
        this.editedItem.id = response.data.user.id
        this.editedItem.image = response.data.user.image
        this.editedItem.picture = response.data.user.picture

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('users/' + this.editedItem.id, this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/CommitteeForm.vue